var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{attrs:{"sitekey":this.sitekey,"loadRecaptchaScript":true,"required":""},on:{"verify":_vm.validate}})}
var staticRenderFns = []

export { render, staticRenderFns }